import React, { Component } from 'react';
import { Layout, Row, Col, Menu, Dropdown, Icon } from 'antd';
import { NavLink, withRouter } from 'react-router-dom';
import * as actions from '../../actions/index';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import GoogleLogout from 'react-google-login';
import logo from './alumni-logo.png';
import SAFlogo from '../Inc/saflogo.jpg'
import Skeleton from 'react-loading-skeleton';
import './layout.css';
import './responsive_style.css'
import Session from '../HOC/Session'
import { UserSwitchOutlined } from '@ant-design/icons';
const { Header } = Layout;


class LayoutHeader extends Component {

  constructor(props) {
    super(props)
    this.logout = this.logout.bind(this);
    this.state = {
      ...props,
      panelView : ''
    }
  }

  logout = () => {

    this.props.actions.logout()
  }

  componentDidMount = () => {
    let loggedinUser = JSON.parse(localStorage.getItem('user'))
    let personGUID = loggedinUser.personGuid;
    this.props.actions.getProfileInfo(personGUID)
    this.props.actions.isadmin()
    let getPanelView = localStorage.getItem("panelView") ?  JSON.parse(localStorage.getItem("panelView")) : "alumniTabView"
    this.setState({
      panelView: getPanelView
    })
  }

  render() {
    return (
      <div>
        <Session />
        <Header>
          <Row type="flex" justify="center" align="middle">
            <Col xs={6} md={18} lg={18}>
              <Row type="flex" justify="start" align="middle">
                <Col md={2} lg={1} xs={1}>
                  <div className="logo">
                    <img src={logo} />
                  </div>
                </Col>
                <Col xs={6} md={16} lg={12} className="hidden-sm">
                  <div className="TitleName">
                    <div className='align-baseline'>
                      <span className="logo-title">
                      Scouting Alumni
                      </span>
                      <span className="logo-slogan">
                        Directory {process.env.REACT_APP_VERSION}
                      </span>
                    </div>
                    <span className='logo-des'>Once a Scout, Always a Scout</span>
                  </div>
                </Col>
              </Row>
            </Col>
            <Col md={6} lg={6} xs={18}>
              <Dropdown overlay={<Menu>
                <Menu.Item key="/my-profile"> <NavLink to="/my-profile"><Icon type="user" />  My Profile </NavLink> </Menu.Item>
                <Menu.Item key="/manage-memberid"> <NavLink to="/manage-memberid"><UserSwitchOutlined />  Manage My Member ID </NavLink> </Menu.Item>
                {
                  this.state.panelView === 'adminTabView' && this.props.isSuperAlumniAdmin &&
                  <Menu.Item key="/Promo-Code-Portal"> <NavLink to="/Promo-Code-Portal"><i className="fa fa-barcode" aria-hidden="true" /> Promo Code Portal </NavLink> </Menu.Item>
                }
                {
                  this.state.panelView === 'adminTabView' &&
                  <Menu.Item key="/nesa-bulk-upload"> <NavLink to="/nesa-bulk-upload"><i className="fa fa-gift" aria-hidden="true" /> Bulk Membership Purchase </NavLink> </Menu.Item>

                }
                <Menu.Item onClick={(e) => this.props.actions.manualLogout()}>
                  <div> <Icon type="logout" /> Logout </div>
                  {/* <GoogleLogout
                    clientId="364170442919-3teb9cg74dt5583vog2brqvnhu8qlkd5.apps.googleusercontent.com"
                    buttonText="Logout"
                  >
                  </GoogleLogout> */}
                </Menu.Item>
              </Menu>}>
                <a className="ant-dropdown-link welcome-dropdown" trigger={['click']} href="#">
                  Welcome, {this.props.profileinfo ? this.props.profileinfo.profile.fullName : <Skeleton width={100} />} <Icon type="down" />
                </a>
              </Dropdown>
            </Col>
          </Row>
        </Header>
      </div>
    );
  }

}

function mapStateToProps(state) {
  return {
    isadmin: state.isadminreducer.isadmin,
    logout: state.authenticationReducer.logout,
    profileinfo: state.profilereducer.profileinfo,
    isSuperAlumniAdmin: state.isadminreducer.isSuperAlumniAdmin,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  }
}

export default compose(connect(mapStateToProps, mapDispatchToProps), withRouter)(LayoutHeader);


// WEBPACK FOOTER //
// ./src/components/Inc/Header.js